import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { CHOOSE_YOUR_QUANTITY_COMPONENT } from '../../../brands/default/content/components/deal';
import Icon from '../../Icon';

const ChooseYourQuantity = () => {
  return (
    <>
      <div className={`modal_qu_social_cue`}>
        <Icon
          align="0px"
          color="#1561db"
          faIcon={faInfoCircle}
          padding={'0px 5px 0px 0px;'}
        />{' '}
        <p>{CHOOSE_YOUR_QUANTITY_COMPONENT.chooseYourQuantity}</p>
      </div>
      <style jsx>{`
        .modal_qu_social_cue {
          align-items: center;
          background: #3074ff21;
          border-left: 3px solid #1561db;
          border-radius: 0 5px 5px 0;
          border: 1px solid #eee;
          color: #1561db;
          display: flex;
          justify-content: flex-start;
          margin-bottom: 8px;
          opacity: 1;
          padding: 5px 10px;
          position: relative;
          transition: opacity 0.5s ease-out;
        }

        .svg-inline--fa {
          margin-right: 10px;
          flex-shrink: 0;
          cursor: pointer;
        }
        .modal_qu_social_cue p {
          margin: 0;
        }
      `}</style>
    </>
  );
};

export default ChooseYourQuantity;
